<template>
  <div>
    <div v-for="card of cards" :key="card.last4" :id="`card_${card.last4}`">
      <div class="card">
        <div class="card__front card__part">
          <img class="card__front-square card__square" src="/images/card/little_square.png" />
          <img class="card__front-logo card__logo" src="/images/card/visa.png" />
          <p class="card_numer">**** **** **** {{card.last4}}</p>
          <div class="card__space-75">
            <span class="card__label">{{ $t('pages.billing.expirationDate') }}</span>
            <p class="card__info">{{props.card.name || props.name}}</p>
          </div>
          <div class="card__space-25">
            <span class="card__label"></span>
            <p
              class="card__info"
            >{{("0" + props.card.exp_month).slice(-2)}}/{{props.card.exp_year.substr(2)}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  functional: true,
  props: ['name', 'card']
}
</script> 